import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIntegrationOutlineRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m7.4 9-2 3.8a1.3 1.3 0 1 0 1.2.7L9 9.2a1 1 0 0 0-.2-1 2.5 2.5 0 1 1 3.7-2.3.8.8 0 0 0 1.5 0A4 4 0 0 0 6.1 5a4 4 0 0 0 1.3 4m3.7-2.5a1.3 1.3 0 1 0-1.3.7l2.5 4.3a1 1 0 0 0 1 .3 2.5 2.5 0 1 1 0 4.4 1 1 0 0 0-1 .3 1 1 0 0 0 .2 1 4 4 0 0 0 4.8-.7 4 4 0 0 0-4-6.6zm3.4 8.8a1.3 1.3 0 1 0-1-2H8.8a1 1 0 0 0-.8.7 2.5 2.5 0 1 1-3.8-2.1.8.8 0 0 0-.8-1.3 4 4 0 1 0 6 4.1h4.1q.3.6 1 .6" })
});
export default SvgIntegrationOutlineRegularIcon;
